import { render } from "./BuildingSubItem.vue?vue&type=template&id=e69b8124"
import script from "./BuildingSubItem.vue?vue&type=script&lang=js"
export * from "./BuildingSubItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__